import MenuHideIcon from "assets/images/contract-left-line.png";
import ExpandMenuIcon from "assets/images/expand-menu.png";
import HomeIcon from "assets/images/home.svg";
import { ReactComponent as MiniLogo } from "assets/images/logo.svg";
import { ReactComponent as MobileLogo } from "assets/images/mobilelogo.svg";
import MenuShowIcon from "assets/images/sidebarshow-icon.svg";
import classNames from "classnames";
import UserIcon from "assets/images/user.svg";
import HousingIcon from "assets/images/housing-expense-request.svg";
import Configuration from "assets/images/gear.svg";
import HousingDatabaseIcon from "assets/images/housing-database.svg";
// import LatestRelease from 'components/release/LatestRelease';
import {
  CONFIGURATION_PATH,
  DASHBOARD_PATH,
  HEALTH_PLANS_PATH,
  HOUSING_DATABASE_PATH,
  HOUSING_EXPENSE_REQUEST_PATH,
  Members_PATH,
  USERS_PATH,
} from "constants/routePaths";
import React, { useState } from "react";
import { Accordion, Offcanvas } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { getUserRole, getFilteredRoutes } from "utils/common";

import "./sidebar.scss";

const Sidebar = () => {
  const [showLabels, setShowLabel] = useState(true);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const toggleSidebarStyle = () => setShowLabel((pre) => !pre);

  const userRole = getUserRole();

  const allRoutes = [
    // {
    //   path: DASHBOARD_PATH,
    //   icon: (
    //     <img src={HomeIcon} className="my-img-svg " width={26} alt="icon" />
    //   ),
    //   label: "Dashboard",
    // },
    {
      path: Members_PATH,
      icon: (
        <img src={UserIcon} className="my-img-svg " width={26} alt="icon" />
      ),
      label: "Members",
    },
    {
      path: HOUSING_EXPENSE_REQUEST_PATH,
      icon: (
        <img src={HousingIcon} className="my-img-svg " width={26} alt="icon" />
      ),
      label: "Housing Expense Request",
    },
    {
      path: HOUSING_DATABASE_PATH,
      icon: (
        <img
          src={HousingDatabaseIcon}
          className="my-img-svg "
          width={26}
          alt="icon"
        />
      ),
      label: "Property Database",
    },
    {
      path: HEALTH_PLANS_PATH,
      icon: (
        <img src={HousingIcon} className="my-img-svg " width={26} alt="icon" />
      ),
      label: "Health Plans",
    },
    {
      path: USERS_PATH,
      icon: (
        <img src={UserIcon} className="my-img-svg " width={26} alt="icon" />
      ),
      label: "Users",
    },
    {
      path: CONFIGURATION_PATH,
      icon: (
        <img
          src={Configuration}
          className="my-img-svg "
          width={26}
          alt="icon"
        />
      ),
      label: "Configuration",
    },
  ];

  // Filter routes based on user role
  const routes = getFilteredRoutes(allRoutes, userRole);

  const renderLinks = (showLabels) => {
    return routes.map((route, index) => (
      <NavLink to={route.path} key={index} onClick={handleClose}>
        <p className="menu-linkk">
          {React.cloneElement(route.icon)}
          {showLabels && <span className="heading-smb">{route.label}</span>}
        </p>
      </NavLink>
    ));
  };
  const navMain = (
    <>
      <div className="logo-menu-otr">
        <div className="logo-otr">
          <MiniLogo />
        </div>
        <div className="menu-icon-otr" onClick={toggleSidebarStyle}>
          <img src={MenuHideIcon} alt="icon" />
        </div>
      </div>
      <Accordion defaultActiveKey="4">
        {renderLinks(showLabels)}{" "}
        {/* Render links dynamically using the renderLinks function */}
      </Accordion>
    </>
  );

  const navMini = (
    <>
      {/* <div className="menu-icon-otr" onClick={toggleSidebarStyle}>
        <img src={MenuHideIcon} alt="icon" />
      </div> */}
      <div className="logo-menu-otr">
        <div className="logo-otr">
          <p className="showsidebar-header">
            <MobileLogo style={{ marginLeft: "15px" }} />
          </p>
        </div>
      </div>
      <Accordion defaultActiveKey="4">
        {renderLinks(showLabels)}{" "}
        {/* Render links dynamically using the renderLinks function */}
      </Accordion>
    </>
  );

  const navMobile = (
    <>
      <div
        className="show-sidebar-icon"
        onClick={handleShow}
        style={{ width: "max-content" }}
      >
        <img className="logo-space" src={MenuShowIcon} alt="icon" />
        {/* <p className="showsidebar-header pt-3 ps-2">
          <MobileLogo />
        </p> */}
      </div>
      <Offcanvas show={show} onHide={handleClose} className="sidebar-offcanvas">
        <Offcanvas.Header closeButton>
          <span></span>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className={`App sidebar-main`}>
            <Accordion defaultActiveKey="4">{renderLinks(true)}</Accordion>
            <div className="bottom-left p-3">
              {/* {<LatestRelease minified={false} withToolTip={false} />} */}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );

  return (
    <>
      {navMobile}
      {!showLabels && (
        <div className="menu-icon-otr-1" onClick={toggleSidebarStyle}>
          <img src={ExpandMenuIcon} alt="icon" width={24} />
        </div>
      )}
      <div
        className={classNames("App sidebar-main hide-side-nav", {
          "sidebar-mini": !showLabels,
        })}
      >
        {showLabels ? navMain : navMini}
        {/* <div className="bottom-left p-2">{<LatestRelease minified={!showLabels} />}</div> */}
      </div>
    </>
  );
};

export default Sidebar;
